import { Injectable } from '@angular/core';
import {APIService} from "./api.service";
import {IUpdateGameRulesCommand} from "../interfaces/IUpdateGameRulesCommand";
import {IGameRules} from "../interfaces/IGameRules";
import {IAddGameRules} from "../interfaces/IAddGameRules";
import {concatMap, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GameRulesService {

  constructor(private apiService: APIService) { }

  getGameRules(gameIdP: string) {
    return this.apiService.MakeGetRequest<IGameRules>("game-rules/" + gameIdP);
  }

  updateGameRules(gameTos: IUpdateGameRulesCommand) {
    return this.apiService.MakePutRequest<IGameRules>("game/game-rules", gameTos);
  }

  addGameRules(gameTos: IAddGameRules): Observable<IGameRules> {
    return this.apiService.MakePostRequest<IGameRules>("game/game-rules", gameTos).pipe(concatMap(() => {
      return this.getGameRules(gameTos.GameId)
    }));
  }
}
